const dashboardFindings = ({ emailSendLimit = 0, emailSentCount = -1, inboxes = [], credits = null, unread = 0, hasWidgets = false, actions = {} } = {}) => {
  const out = [];
  if (emailSendLimit > 0 && emailSentCount >= emailSendLimit) {
    out.push({ tone: "bad", key: "send_limit", label: "Send limit reached", text: "Nothing more sends this period. Upgrade or wait.", actions: actions.billing ? [{ label: "Open billing", run: actions.billing }] : [] });
  }
  (inboxes || []).filter(i => i.status === "DISCONNECTED" || i.disconnected).forEach(i =>
    out.push({ tone: "bad", key: "inbox_disconnected", label: `${i.email} needs reconnecting`, text: "Sequences on this inbox are stalled.", actions: actions.accounts ? [{ label: "Reconnect", run: actions.accounts }] : [] })
  );
  if (credits !== null && credits < 50) {
    out.push({ tone: "warn", key: "low_credits", label: `${credits} credits left`, text: "Enrichment and reveals will stop soon.", actions: actions.credits ? [{ label: "Buy credits", run: actions.credits }] : [] });
  }
  if (unread > 0) {
    out.push({ tone: "hot", key: "unread", label: `${unread} unread ${unread === 1 ? "reply" : "replies"}`, text: "Answer these before anything else today.", actions: actions.inbox ? [{ label: "Open inbox", run: actions.inbox }] : [] });
  }
  if (hasWidgets) {
    out.push({ tone: "neutral", key: "explain_widget", label: "Explain a number", text: "Name any widget and I will explain the change behind it.", actions: actions.explainWidget ? [{ label: "Explain a number", run: actions.explainWidget }] : [] });
  }
  return out;
};

export default dashboardFindings;
